export const COMPONENT_MAP_NAMES = {
  HUB: 'HUB',
  ONBOARDING: 'ONBOARDING',
  SPINNER: 'SPINNER',
  COMING_SOON: 'COMING_SOON',
  UPGRADE: 'UPGRADE',
};
